import { useRegisterSW } from 'virtual:pwa-register/react';

export default function UpdateNotification() {
  const { needRefresh: [needRefresh], updateServiceWorker } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '1.25rem',
      right: '1.25rem',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      padding: '0.75rem 1rem',
      background: '#1e293b',
      border: '1px solid #334155',
      borderRadius: '0.5rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
      color: '#e2e8f0',
      fontSize: '0.875rem',
      maxWidth: '320px',
    }}>
      <span>A new version is available.</span>
      <button
        onClick={() => updateServiceWorker(true)}
        style={{
          padding: '0.3rem 0.75rem',
          background: '#3b82f6',
          border: 'none',
          borderRadius: '0.375rem',
          color: '#fff',
          cursor: 'pointer',
          fontSize: '0.8rem',
          fontWeight: 500,
          whiteSpace: 'nowrap',
        }}
      >
        Reload
      </button>
    </div>
  );
}
